import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  SET_USER,
  CLEAR_USER,
  TOKEN_EXPIRED,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  VERIFY_RESET_TOKEN_REQUEST,
  VERIFY_RESET_TOKEN_SUCCESS,
  VERIFY_RESET_TOKEN_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  CLEAR_FORGOT_PASSWORD_STATE
} from '../constants/authConstants';


// Token validation utility
const isTokenValid = (token) => {
  if (!token) return false;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    return payload.exp > currentTime;
  } catch (error) {
    return false;
  }
};

const getInitialState = () => {
  const token = sessionStorage.getItem('authToken');
  const user = sessionStorage.getItem('user');
  
  if (token && user && isTokenValid(token)) {
    try {
      return {
        user: JSON.parse(user),
        token,
        isAuthenticated: true,
        loading: false,
        error: null,
        forgotPassword: {
          loading: false,
          success: false,
          error: null,
          message: null
        },
        resetPassword: {
          loading: false,
          success: false,
          error: null,
          message: null,
          tokenValid: false
        }
      };
    } catch (error) {
      sessionStorage.removeItem('authToken');
      sessionStorage.removeItem('user');
    }
  } else if (token) {
    // Token exists but is invalid/expired
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('user');
  }
  
  return {
    user: null,
    token: null,
    isAuthenticated: false,
    loading: false,
    error: null,
    forgotPassword: {
      loading: false,
      success: false,
      error: null,
      message: null
    },
    resetPassword: {
      loading: false,
      success: false,
      error: null,
      message: null,
      tokenValid: false
    }
  };
};

const initialState = getInitialState();

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        user: action.payload.user,
        token: action.payload.token,
        error: null
      };

    case LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        user: null,
        token: null,
        error: action.payload
      };

    case LOGOUT_REQUEST:
      return {
        ...state,
        loading: true
      };

    case LOGOUT_SUCCESS:
    case CLEAR_USER:
    case TOKEN_EXPIRED:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        user: null,
        token: null,
        error: null
      };

    case SET_USER:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true
      };

    // Forgot Password Cases
    case FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          loading: true,
          error: null,
          success: false
        }
      };

    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          loading: false,
          success: true,
          message: action.payload,
          error: null
        }
      };

    case FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          loading: false,
          success: false,
          error: action.payload,
          message: null
        }
      };

    // Verify Reset Token Cases
    case VERIFY_RESET_TOKEN_REQUEST:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          loading: true,
          error: null
        }
      };

    case VERIFY_RESET_TOKEN_SUCCESS:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          loading: false,
          tokenValid: true,
          error: null
        }
      };

    case VERIFY_RESET_TOKEN_FAILURE:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          loading: false,
          tokenValid: false,
          error: action.payload
        }
      };

    // Reset Password Cases
    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          loading: true,
          error: null,
          success: false
        }
      };

    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          loading: false,
          success: true,
          message: action.payload,
          error: null
        }
      };

    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          loading: false,
          success: false,
          error: action.payload,
          message: null
        }
      };

    case CLEAR_FORGOT_PASSWORD_STATE:
      return {
        ...state,
        forgotPassword: {
          loading: false,
          success: false,
          error: null,
          message: null
        },
        resetPassword: {
          loading: false,
          success: false,
          error: null,
          message: null,
          tokenValid: false
        }
      };



    default:
      return state;
  }
};

export default authReducer;